import { render } from "./ic-user.vue?vue&type=template&id=faf43e40&ts=true"
import script from "./ic-user.vue?vue&type=script&lang=ts"
export * from "./ic-user.vue?vue&type=script&lang=ts"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__